export enum UserRole {
  CancellationRequest = 'CANCELLATION_REQUEST',
  Claim = 'CLAIM',
  Registration = 'REGISTRATION',
  Order = 'ORDER',
  MasterdataChange = 'MASTERDATA_CHANGE',
  CallbackRequest = 'CALLBACK_REQUEST',
  PushMessages = 'PUSH_MESSAGES',
}
